import { render, staticRenderFns } from "./FDialog.vue?vue&type=template&id=080bdcaf&"
import script from "./FDialog.vue?vue&type=script&lang=ts&"
export * from "./FDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports